import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useAdvertiserDirectoryFeedStore = defineSmartFeedPiniaStore("advertiser-directory-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    feedUrl: "/org/advertisers/smart-feed",
    metadata: {
      lastId: Number.MAX_SAFE_INTEGER,
    },
  }),
});
